import { render, staticRenderFns } from "./UserFormCredentials.vue?vue&type=template&id=22f2604a&"
import script from "./UserFormCredentials.vue?vue&type=script&lang=js&"
export * from "./UserFormCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports